import { isFunction } from "../utils";
import Fingerprint2 from "fingerprintjs2";

let __isLookingUpDeviceFingerprint__ = false;

const MAX_FINGERPRINT_ATTEMPTS = 5;

const __scheduler__ = (function __requestIdleCallbackScheduler__() {
  if ('requestIdleCallback' in self && isFunction(requestIdleCallback)) {
    return {
      schedule: requestIdleCallback.bind(self),
      cancel: cancelIdleCallback.bind(self)
    };
  }

  return {
    schedule: function __requestIdleCallback__(callback) {
      if (isFunction(callback)) {
        const start = Date.now();

        return setTimeout(function __timerCallback__() {
          callback({
            didTimeout: false,
            timeRemaining() {
              return Math.max(0, 50 - (Date.now() - start));
            }
          });
        }, 1);
      }
    },

    cancel: function __cancelIdleCallback__(timerId) {
      timerId && clearTimeout(timerId);
    }
  };
})();

function __getDeviceFingerprint__() {
  if (__isLookingUpDeviceFingerprint__) return Promise.resolve(null);

  __isLookingUpDeviceFingerprint__ = true;

  return new Promise((resolve) => {
    let __fingerprintAttempts__ = 0;

    __scheduler__.schedule(function __fingerprint__(deadline) {
      if (deadline.timeRemaining() > 0) {
        return Fingerprint2.get((components) => {
          try {
            const values = components.map(component => component.value).join('');
            resolve(Fingerprint2.x64hash128(values, 31));
          } catch (e) {
            if (++__fingerprintAttempts__ < MAX_FINGERPRINT_ATTEMPTS) {
              __scheduler__.schedule(__fingerprint__);
            } else {
              resolve(null);
            }
          }
        });
      }

      if (++__fingerprintAttempts__ < MAX_FINGERPRINT_ATTEMPTS) {
        __scheduler__.schedule(__fingerprint__);
      } else {
        resolve(null);
      }
    });
  }).finally(() => {
    __isLookingUpDeviceFingerprint__ = false;
  });
}

onmessage = function () {
  __getDeviceFingerprint__().then(postMessage);
};
